import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../App';
import { dashboard } from '../api';
import { Users, Building2, Download } from 'lucide-react';

export default function Dashboard() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    dashboard.stats().then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--primary)', marginBottom: 6 }}>
        {t('dashboard')}
      </h1>
      <p style={{ color: 'var(--gray)', marginBottom: 28 }}>
        {t('welcomeBack')}, {user?.username}
      </p>

      <div className="grid-3" style={{ marginBottom: 28 }}>
        <div className="stat-card">
          <div style={{ color: 'var(--accent)', marginBottom: 8 }}><Users size={28} /></div>
          <div className="stat-number">{stats?.total_clients ?? '—'}</div>
          <div className="stat-label">{t('totalClients')}</div>
        </div>
        <div className="stat-card">
          <div style={{ color: '#059669', marginBottom: 8 }}><Building2 size={28} /></div>
          <div className="stat-number" style={{ color: '#059669' }}>{stats?.ahmedabad_clients ?? '—'}</div>
          <div className="stat-label">{t('ahmedabadClients')}</div>
        </div>
        <div className="stat-card">
          <div style={{ color: '#D97706', marginBottom: 8 }}><Building2 size={28} /></div>
          <div className="stat-number" style={{ color: '#D97706' }}>{stats?.palanpur_clients ?? '—'}</div>
          <div className="stat-label">{t('palanpurClients')}</div>
        </div>
      </div>

      <div className="card">
        <h3 style={{ fontWeight: 700, color: 'var(--primary)', marginBottom: 12 }}>Quick Links</h3>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <a href="/clients" className="btn btn-secondary">
            <Users size={15} /> {t('clientDatabase')}
          </a>
          <a href="/downloads" className="btn btn-primary">
            <Download size={15} /> {t('downloads')}
          </a>
        </div>
      </div>
    </div>
  );
}
